
export default class TransactionPolicy
{

    static seeOrderTransactions(user)
    {
        return user.role_name === 'customer';
    }

    static manage(user)
    {
        return user && user.role_name === 'admin' && user.role === 3;
    }

}